<template>
  <div class="news-center">

    <!-- 一级标题 -->
    <div class="mlbox">
      <div>{{ firstTitle.cn }}</div>
      <div class="pctitle">{{ firstTitle.en }}</div>
    </div>

    <!-- 主内容区：左侧树 + 右侧文章 -->
    <div class="main-content">
      <!-- 左侧：标题 + 树（封装为独立组件） -->
      <NewsTree :secondLevelList="secondLevelList" :firstTitle="firstTitle" @select="handleTreeSelect"/>

      <!-- 右侧文章列表区 -->
      <div class="right-content">
        <div class="article-list" v-if="articleList.length > 0">
          <div class="article-item" v-for="item in pagedArticleList" :key="item.menuId" @click="openArticle(item)">
            <div class="article-item-title">{{ item.menuName }}</div>
            <div class="article-item-date">{{ formatDate(item.createTime) }}</div>
          </div>
        </div>
        <div v-else class="empty-tip">{{ loadTip }}</div>

        <!-- 分页：超过一页时显示 -->
        <div v-if="articleList.length > pageSize" class="article-pagination">
          <el-pagination background layout="total, prev, pager, next, jumper" :total="articleList.length"
                         :page-size="pageSize" :current-page.sync="currentPage"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewsTree from './NewsTree.vue'

// 视为文章的栏目类型（C=文件，F=图文）
const ARTICLE_MENU_TYPES = ['C', 'F']

export default {
  name: 'NewsCenter',
  components: {NewsTree},
  props: {
    // 新闻主栏目 ID（默认 1599）
    rootId: {
      type: Number,
      default: 1599
    },
    // 完整的栏目树（由父组件请求并传入）
    columnTree: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      // 一级标题（传给 NewsTree）
      firstTitle: {
        cn: '新闻中心',
        en: 'NEWS CENTER'
      },
      // 新闻主栏目（缓存以便"取消选中"时取所有文章）
      newsRoot: null,
      // 二级分类（传给 NewsTree）
      secondLevelList: [],
      // 右侧文章列表
      articleList: [],
      // 提示文案
      loadTip: '暂无数据…',
      // 分页
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    // 当前页展示的文章切片
    pagedArticleList() {
      const start = (this.currentPage - 1) * this.pageSize
      return this.articleList.slice(start, start + this.pageSize)
    }
  },
  watch: {
    // 父组件传入的 columnTree 变化时重新初始化
    columnTree: {
      immediate: true,
      handler(tree) {
        this.initNews(tree)
      }
    },
    // 切换栏目时重置到第 1 页
    articleList() {
      this.currentPage = 1
    }
  },
  methods: {
    // 通用：日期格式化
    formatDate(val) {
      if (!val) return ''
      if (typeof val === 'string') {
        return val.length >= 10 ? val.slice(0, 10) : val
      }
      return ''
    },
    // 从树中找到指定 ID 的节点
    findNodeById(tree, id) {
      if (!tree || tree.length === 0) return null
      for (let node of tree) {
        if (node.menuId === id) return node
        if (node.children && node.children.length > 0) {
          const found = this.findNodeById(node.children, id)
          if (found) return found
        }
      }
      return null
    },
    // 根据 columnTree 找到 rootId 对应的节点并初始化
    initNews(tree) {

      const newsRoot = this.findNodeById(tree, this.rootId)
      if (!newsRoot || !newsRoot.children || newsRoot.children.length === 0) {
        this.loadTip = '暂无新闻数据'
        this.secondLevelList = []
        this.articleList = []
        return
      }
      // 缓存新闻主栏目
      this.newsRoot = newsRoot
      // 第一级标题
      this.firstTitle.cn = newsRoot.menuName
      this.firstTitle.en = newsRoot.remark
      this.secondLevelList = newsRoot.children
      // 默认展示新闻下所有文章
      this.articleList = this.collectArticles(newsRoot)
    },
    // 递归收集某节点下所有"文章"（C/F 类型栏目）
    collectArticles(node) {
      const result = []
      const walk = n => {
        if (!n) return
        if (ARTICLE_MENU_TYPES.indexOf(n.menuType) !== -1) {
          result.push(n)
        }
        if (n.children && n.children.length > 0) {
          for (let c of n.children) walk(c)
        }
      }
      walk(node)
      // 按创建时间倒序
      result.sort((a, b) => {
        return a.parentOrderNum - b.parentOrderNum || a.parentId - b.parentId || a.orderNum - b.orderNum
      })
      return result
    },
    // 处理左侧树选中事件：
    //   node 为 null  → 取消选中，回退到新闻主栏目下所有文章
    //   node 非 null  → 收集该节点下所有文章
    handleTreeSelect(node) {
      if (node) {
        this.articleList = this.collectArticles(node)
      } else {
        this.articleList = this.collectArticles(this.newsRoot)
      }
    },
    // 跳转至文章详情页（复用 ejml 详情页）
    openArticle(item) {
      if (!item) return
      window.location =
          '/#/ejml?id=' +
          item.menuId +
          '&name=' +
          encodeURIComponent(item.menuName || '')
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.news-center {
  width: 100%;
}

.mlbox {
  border-left: solid 5px #008D40;
  padding: 0px 10px;
  font-size: 20px;
  font-weight: 600;
}

.pctitle {
  font-size: 10px;
}

/* 主内容区域 */
.main-content {
  display: flex;
  align-items: stretch;
  min-height: 600px;
  margin-top: 20px;
}

/* 右侧文章列表 */
.right-content {
  flex: 1;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
}

.article-list {
  padding-right: 4px;
}

/* 空态：竖直 + 水平居中，字体放大 */
.empty-tip {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #bbb;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 0;
}

.article-pagination {
  margin-top: 24px;
  text-align: center;
}

.article-pagination >>> .el-pagination.is-background .el-pager li,
.article-pagination >>> .el-pagination.is-background .btn-prev,
.article-pagination >>> .el-pagination.is-background .btn-next {
  background: #f5f5f5;
  border: 1px solid #e4e4e4;
  color: #555;
  min-width: 36px;
  height: 36px;
  line-height: 36px;
  font-weight: 500;
}

.article-pagination >>> .el-pagination.is-background .el-pager li.active {
  background: #008d40;
  color: #fff;
  border-color: #008d40;
  font-weight: 700;
  font-size: 15px;
  box-shadow: 0 2px 6px rgba(0, 141, 64, 0.35);
  transform: translateY(-1px);
}

.article-pagination >>> .el-pagination.is-background .btn-prev:hover,
.article-pagination >>> .el-pagination.is-background .btn-next:hover,
.article-pagination >>> .el-pagination.is-background .el-pager li:hover {
  color: #008d40;
  border-color: #008d40;
}

.article-pagination >>> .el-pagination.is-background .el-pager li.active:hover {
  color: #fff;
  background: #007a37;
  border-color: #007a37;
}

.article-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 56px;
  padding: 0 4px;
  border-bottom: 1px dashed #e0e0e0;
  cursor: pointer;
  transition: all 0.2s ease;
  box-sizing: border-box;
  overflow: hidden;
}

.article-item:hover {
  background: #f9fdf9;
  padding-left: 14px;
}

.article-item-title {
  flex: 1;
  font-size: 15px;
  color: #333;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 20px;
  line-height: 1.4;
}

.article-item:hover .article-item-title {
  color: #008d40;
}

.article-item-date {
  font-size: 13px;
  color: #999;
  white-space: nowrap;
  min-width: 90px;
  text-align: right;
}

/* 响应式适配 */
@media screen and (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }

  .right-content {
    padding: 0;
  }

  .article-item-title {
    font-size: 14px;
  }
}
</style>
